import { alphabeticalSort } from '@cims-online/shared'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import UserTags from 'components/CIMSTags/common/UserTags'
import { HelpMessage } from 'utils/constants'
import {
  RFIResponseDiscipline,
  useResponseDisciplinesTableContext,
} from '../../../ResponseDisciplinesTableContext'

export const useColumns = (): CIMSColumn<RFIResponseDiscipline>[] => {
  const { records } = useResponseDisciplinesTableContext()
  return [
    useNameColumn({
      help: HelpMessage.RequestsForInformation.ResponseDisciplines.Name,
      sort: { default: 'ascend' },
    }),
    useOptionalDescriptionColumn('Response Discipline'),
    {
      title: 'Responders',
      width: 300,
      help: HelpMessage.RequestsForInformation.ResponseDisciplines.Responders,
      render: ({ users }) => <UserTags users={users} />,
      filter: {
        with: 'callback',
        items: records
          ?.flatMap(({ users }) => users)
          .map(({ id, displayName, mail }) => ({
            text: displayName ?? mail,
            value: id,
          }))
          .sort(alphabeticalSort('text')),
        onFilter: (value, { users }) => users.some(({ id }) => id === value),
      },
    },
  ]
}
